<template>
  <div class="widget-text-filter" :style="styleColor">
    <a-input v-model.trim="textValue" :placeholder="placeholder" @input="textInput"  :style="styleInput"/>
  </div>
</template>
<script>

export default {
  name: "WidgetButton",
  components: {
  },
  props: {
    value: Object,
    ispreview: Boolean,
    compIndex: Number
  },
  inject: ["setFilterCondition", "getFilterCondition"],
  data() {
    return {
      textValue: '',
      options: {
      },
      dateRange: [],
    };
  },
  computed: {
    placeholder() {
      let list = this.value.data.dynamicData
      if (list.length > 0) {
        return Array.from(new Set(list.map(v => v.dimensionName))).toString();
      } else {
        return '请输入'
      }
    },
    transStyle() {
      return this.$objToOne(this.options);
    },
    styleInput() {
      return {
        "font-size": this.transStyle.fontSize + "px" || "14px",
      }
    },
    styleColor() {
      return {
        position: this.ispreview ? "absolute" : "static",
        color: this.transStyle.color || "#fff",
        value: this.transStyle.value || [],
        "letter-spacing": this.transStyle.letterSpacing + "em",
        background: this.transStyle.background,
        "font-weight": this.transStyle.fontWeight,
        "text-align": this.transStyle.textAlign,
        display:
          this.transStyle.hideLayer == undefined
            ? "block"
            : this.transStyle.hideLayer
            ? "none"
            : "block",
        width: this.transStyle.width + "px",
        height: this.transStyle.height + "px",
        left: this.transStyle.left + "px",
        top: this.transStyle.top + "px",
        right: this.transStyle.right + "px"
      };
    }
  },
  watch: {
    value: {
      handler(val) {
        this.options = val;
        if(!this.ispreview) {
          this.textValue = val.data.text
        }
      },
      deep: true
    },
  },
  mounted() {
    this.options = this.value;
    this.textValue = this.value.data.text
  },
  methods: {
    textInput() {
      this.setFilterCondition(this.compIndex, this.textValue)
    }
  }
};
</script>
<style lang="less" scoped>
.widget-text-filter {
  width: 100%;
  height: 100%;
  .ant-input {
    height: 100%;
    width: 100%;
  }
}
</style>